import React from 'react';
import DataTables from 'components/dataTables';
import { connect } from 'react-redux';
import { UserAction, UsersGroupsAction } from 'redux/actions';
import PageSpinner from 'components/PageSpinner';
import { Card, Badge, Button } from 'reactstrap';
import UsersContainer from './usersContainer';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import noImage from 'assets/img/users/no-image.jpg';
import Avatar from 'components/Avatar';
import PopupWindow from 'components/ModalPopup';
import AssignGroup from './assignGroup';
import AddUser from './addUser';
import { Link } from 'react-router-dom';
import { checkPermissions } from 'hooks';

const BackendUsers = (props) => {
    const [open, setOpen] = React.useState(false);
    const [userOpen, setUserOpen] = React.useState(false);

    const isFirstRender = React.useRef(true);
    React.useEffect(() => {
        if (isFirstRender.current) {
            let filters = { list: 1 }
            props.getUsersGroups(filters);
            isFirstRender.current = false;
        }
    })

    React.useEffect(() => {
        let filters = { page: props.pagination.page, page_limit: props.pagination.page_limit, order_by: props.order.order_by, direction: props.order.direction }
        props.getUsers(filters);
        setOpen(false);
    }, [props.pagination, props.order, props.groupAssigned]);


    React.useEffect(() => {
        let filters = { page: props.pagination.page, page_limit: props.pagination.page_limit, order_by: props.order.order_by, direction: props.order.direction }
        props.getUsers(filters);
        setUserOpen(false);
    }, [props.userAdded]);


    React.useEffect(() => {
        props.getTotalCount(props.totalRecord)
    }, [props.totalRecord])

    const profilePicture = (value, tableMeta, updateValue) => {
        return (<Avatar src={(value) ? value : noImage} />);
    }

    const getRoleList = (value, tableMeta, updateValue) => {
        return <div>
            {(value && value.length > 0) && value.map((item, index) => (<Badge key={index} style={{ padding: 6, marginTop: 2, marginBottom: 2 }} color="primary" pill className="mr-1">{item.auth_group.name}</Badge>))}
        </div>
    }



    const assignRoleButton = (value, tableMeta, updateValue) => {
        let assignedGroups = (tableMeta.rowData[5]) ? tableMeta.rowData[5] : [];
        assignedGroups = assignedGroups.map((item) => item.auth_group.id);
        const userId = (tableMeta.rowData[0]) ? tableMeta.rowData[0] : [];
        return (
            <div className='action-buttons'>
                {(checkPermissions(props.loginData, 'assign-groups')) ?
                    <PopupWindow btnClass={'assign-group'} handlePopup={() => { }} openWindow={open} title={'Assign Role'} launchButtonText={'Assign Group'} >
                        <AssignGroup userId={userId} groups={props.groupsArray} assignedGroups={assignedGroups} />
                    </PopupWindow>
                    : <Button color="primary" disabled={true} className="border-0 btn-disabled" >Assign Role</Button>
                }
                {checkPermissions(props.loginData, 'user_profile') ?
                    <Link className="view-profile-link" style={{ marginLeft: 10 }} to={`/user-profile/${tableMeta.rowData[0]}`}><Button size={'small'} style={{ height: 28 }} color="primary" className="border-0 view-profile" >View Profile</Button></Link>
                    : <Button style={{ marginLeft: 10 }} color="primary btn-disabled" disabled={true} className="border-0" >View Profile</Button>
                }
                {checkPermissions(props.loginData, 'user_permissions') ?
                    <Link className="user-permission-link" style={{ marginLeft: 10 }} to={`/manage-user-permissions/${tableMeta.rowData[0]}`}><Button size={'small'} style={{ height: 28 }} color="primary" className="border-0 view-permissions" >Permissions</Button></Link>
                    : <Button style={{ marginLeft: 10 }} color="primary btn-disabled" disabled={true} className="border-0" >Permissions</Button>
                }
            </div>
        )
    }

    const columns = () => {
        let columnsList = [
            {
                name: "id",
                label: "S.No.",
            },
            {
                name: "avatar",
                label: "Image",
            },
            {
                name: "name",
                label: "Name",
            },
            {
                name: "email",
                label: "Email",
            },
            {
                name: "phone",
                label: "Phone",
            },
            {
                name: "auth_user_group",
                label: "Role",
            },
            {
                name: "action",
                label: "Action",
            }
        ];
        return columnsList.map((column, index) => {
            return {
                label: column.label,
                name: column.name,
                options: {
                    setCellProps: () => ({
                        style: (column.name === 'action') ? { width: '34%' } : { width: 'auto' }
                    }),
                    display: (column.name === 'id') ? false : true,
                    customBodyRender:
                        (column.name === 'avatar') ? profilePicture :
                            (column.name === 'auth_user_group') ? getRoleList :
                                (column.name === 'action') ? assignRoleButton :
                                    (value) => value,
                    customHeadRender: (columnMeta, updateDirection) => {
                        return <TableCustomHeader key={index} itemkey={index} order={props.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                    },
                }
            }
        })
    }

    return (
        <div>
            {(checkPermissions(props.loginData, 'create_user')) &&
                <div style={{ width: 100, marginLeft: 'auto', marginBottom: 10 }}>
                    <PopupWindow btnClass={'add-new-user'} handlePopup={(flag) => setUserOpen(flag)} openWindow={userOpen} title={'Add New User'} launchButtonText={'Add New User'} >
                        <AddUser isAdmin={true} />
                    </PopupWindow>
                </div>
            }

            <Card className="mb-3">

                {props.isLoading ? <PageSpinner />
                    : <DataTables data={props.adminUsers} columns={columns()} options={props.options} />
                }
            </Card>
        </div>
    );
}
const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    userAdded: (state.user && state.user.userAdded) ? state.user.userAdded : null,
    groupAssigned: (state.groups && state.groups.groupAssigned) ? state.groups.groupAssigned : null,
    groupsArray: (state.groups &&
        state.groups.groupsArray &&
        state.groups.groupsArray.groups) ?
        state.groups.groupsArray.groups : [],
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    adminUsers: (state.user && state.user.adminUsers && state.user.adminUsers.users) ? state.user.adminUsers.users : [],
    totalRecord: (state.user && state.user.adminUsers && state.user.adminUsers.total_users) ? state.user.adminUsers.total_users : 0
});
const mapDispatchToProps = (dispatch) => ({
    getUsers: (payload) => dispatch(UserAction.getAdminUsers(payload)),
    getUsersGroups: (payload) => dispatch(UsersGroupsAction.getUsersGroupsArray(payload)),
});
export default UsersContainer(connect(mapStateToProps, mapDispatchToProps)(BackendUsers), { defaultOrderBy: 'id' });